import { createHead } from '@vueuse/head'

const head = createHead()

export default head
